import React, { useEffect } from "react";

const NotificationToast = ({ title, message }) => {
    useEffect(() => {
        const audio = new Audio("/notification.mp3");
        audio.volume = 0.5;
        audio.play().catch(() => { });
    }, []);

    return (
        <div
            style={{
                background: "linear-gradient(135deg, #ECFDF5, #D1FAE5)",
                border: "1px solid #A7F3D0",
                borderLeft: "8px solid #10B981",
                borderRadius: "16px",
                padding: "18px 22px",
                minWidth: "340px",
                maxWidth: "420px",
                boxShadow: "0 18px 40px rgba(16, 185, 129, 0.25)",
                display: "flex",
                gap: "14px",
                alignItems: "flex-start",
                animation: "slideIn 0.4s ease",
                transition: "transform 0.2s ease",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.03)")}
            onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
        >
            {/* Icon */}
            <div style={{ fontSize: "22px" }}>✅</div>

            {/* Content */}
            <div>
                <p
                    style={{
                        color: "#065F46",
                        fontWeight: 700,
                        fontSize: "16px",
                        marginBottom: "6px",
                    }}
                >
                    {title}
                </p>

                <p
                    style={{
                        color: "#047857",
                        fontSize: "14px",
                        lineHeight: "1.6",
                    }}
                >
                    {message}
                </p>
            </div>

            {/* Animation */}
            <style>
                {`
                @keyframes slideIn {
                    from {
                        opacity: 0;
                        transform: translateX(60px);
                    }
                    to {
                        opacity: 1;
                        transform: translateX(0);
                    }
                }
                `}
            </style>
        </div>
    );
};

export default NotificationToast;